"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWidgetToDashboard = void 0;
const config_1 = require("../../config");
const types_1 = require("../../types");
const command_manager_1 = require("../../command_manager");
const i18n_1 = require("../../exports/i18n");
const store_1 = require("../../exports/store");
const dashboard_1 = require("../../model/dashboard");
const WIDTH = 3;
exports.addWidgetToDashboard = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { dashboardId, widgetIds, cols } = options;
        const dashboardSnapshot = store_1.Selectors.getDashboardSnapshot(state, dashboardId);
        if (!dashboardSnapshot) {
            return null;
        }
        const layout = dashboardSnapshot.widgetInstallations.layout || [];
        if (layout.length + widgetIds.length > Number((0, config_1.getCustomConfig)().DASHBOARD_WIDGET_MAX_NUM)) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.reach_dashboard_installed_limit, { count: (0, config_1.getCustomConfig)().DASHBOARD_WIDGET_MAX_NUM }));
        }
        const newLayouts = widgetIds.map((widgetId, index) => {
            return {
                id: widgetId,
                widthInColumns: WIDTH,
                heightInRoes: 6,
                // calculation formula
                // https://github.com/STRML/react-grid-layout/blob/master/test/examples/6-dynamic-add-remove.jsx
                row: Number.MAX_SAFE_INTEGER,
                column: ((layout.length + index) * WIDTH) % (cols || 12),
            };
        });
        const addWidgetActions = dashboard_1.DashboardAction.addWidget2Action(dashboardSnapshot, { layout: newLayouts });
        if (!addWidgetActions) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: dashboardId,
            resourceType: types_1.ResourceType.Dashboard,
            actions: addWidgetActions,
        };
    },
};
//# sourceMappingURL=add_widget_to_dashboard.js.map